import Vue from 'vue'
import sticky from '@/directives/sticky'
import privateAmount from '@/directives/private-amount'
import privateAmountAdvisory from '@/directives/private-amount-advisory'
import parallax from '@/directives/parallax-effect'
import genericTooltip from '@/directives/generic-tooltip/generic-tooltip'

Vue.directive('sticky', sticky)
Vue.directive('privateAmount', privateAmount)
Vue.directive('privateAmountAdvisory', privateAmountAdvisory)
Vue.directive('parallax', parallax)
Vue.directive('genericTooltip', genericTooltip)
